module.exports = __webpack_public_path__ + "static/media/instagram.009559ba.svg";